/* global app: false */
app.controller('Datalayer.Checkout.Controller', function ($scope, $rootScope, $http) {
    $rootScope.$on('requestQuote', function (event, args) {
        handleBroadcast(event, args);
    });

    function handleBroadcast(event, args) {
        if (args.jsonData && args.carId && args.carId > -1) {
            datalayerEventCheckout(args.jsonData);
        } else if (args.carId && args.carId > -1) {
            $http
                .get(
                    '/Umbraco/Api/DatalayerApi/GetCarJson?id=' +
                        args.carId +
                        '&languageId=' +
                        args.languageId
                )
                .then(
                    //Success
                    function (response) {
                        if (response && response.data) {
                            datalayerEventCheckout(response.data);
                        }
                    },
                    //Error
                    function (response) {
                        console.log(response.data);
                    }
                );
        } else {
            var data = {};
            datalayerEventCheckout(data);
        }
    }

    function datalayerEventCheckout(data) {
        try {
            if (!window.dataLayer || !data || Object.keys(data).length === 0) {
                return;
            }

            //Send GA4 event:
            window.dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    items: [
                        {
                            item_name: data.Title || 'N/A',
                            item_id: data.CarId || data.Id || 'N/A',
                            price: data.DataLayerPrice || 'N/A',
                            item_brand: data.Brand || 'N/A',
                            item_category: data.TaxAddition || 'N/A',
                            item_variant: data.Title.replace(data.Brand, '') || 'N/A',
                            quantity: '1',
                            //Custom fields:
                            subtitle: data.SubTitle || 'N/A',
                            transmission:
                                data.Specifications.find((x) => x.Key == 'Transmissie').Value ||
                                'N/A',
                            carroserie: data.BodyType || 'N/A',
                            doors: data.Doors || 'N/A',
                            fiscalvalue: data.TaxValue || 'N/A',
                            fuel:
                                data.Specifications.find((x) => x.Key == 'Brandstof').Value ||
                                'N/A',
                            brutobijtelling:
                                getNetAddition(data.TaxValue, data.TaxAddition) || 'N/A',
                            nettobijtelling:
                                getGrossAddition(data.TaxValue, data.TaxAddition) || 'N/A',
                            actieauto: data.IsInSale ? 'ja' : 'nee',
                            requesttype: data.DataLayerConsumer,
                        },
                    ],
                },
            });
        } catch (e) {
            console.log('Could not push to Datalayer - Checkout', e);
        }
    }

    function getNetAddition(taxValue, addition) {
        return (taxValue * (addition / 100) * (40.85 / 100)) / 12;
    }

    function getGrossAddition(taxValue, addition) {
        return (taxValue * (addition / 100)) / 12;
    }
});
